import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const AlbumPhotoGroupIcon = ({ color = '#cdd6e3', size = 45, ...props }) => (
  <svg
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    {...props}
  >
    <path
      d="M7.686 10.71c0-1.15.797-2.083 1.775-2.083h33.765c.98 0 1.774.94 1.774 2.083v27.208C45 39.067 44.204 40 43.226 40H9.46c-.98 0-1.775-.94-1.775-2.082V10.71zm3.554 25.108h30.207V12.81H11.24v23.008zM32.872 0h-2.666v4.182h7.107V3.133v13.605V4.182H3.553v27.19h15.993H2.664h.89v-8.366H0v3.143V2.083C0 .933.796 0 1.774 0h31.098zM0 23.006h3.553v6.277c0 1.155-.788 2.09-1.776 2.09-.98 0-1.777-.928-1.777-2.09v-6.277zM30.206 4.182V0h5.332c.98 0 1.775.927 1.775 2.092 0 1.155-.787 2.09-1.775 2.09h-5.332z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

AlbumPhotoGroupIcon.propTypes = propTypes;

export default AlbumPhotoGroupIcon;
